import styled from "@emotion/native"
import { BlurView } from "../BlurView"
import { Text } from "../Typography.tsx"
import Animated, {
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
  useAnimatedStyle,
  withDelay,
} from "react-native-reanimated"
import SynchPayRightSideLogo from "../../assets/onboarding-v2/SynchPayRightSideLogo.svg"
import SynchPayLeftSideLogo from "../../assets/onboarding-v2/SynchPayLeftSideLogo.svg"
import { useEffect } from "react"
import { Spacing } from "../Spacing.tsx"
import { StyleSheet } from "react-native"

const LEFT_INITIAL_VALUE = 6.8
const RIGHT_INITIAL_VALUE = -6.8
const DURATION = 500
const DELAY = 100
const HORIZONTAL_OFFSET = 0.5

type FullScreenBlurProps = {
  loadingText: string
}

export function FullScreenBlur({ loadingText }: FullScreenBlurProps) {
  const leftSideOffset = useSharedValue(LEFT_INITIAL_VALUE)
  const rightSideOffset = useSharedValue(RIGHT_INITIAL_VALUE)

  useEffect(() => {
    leftSideOffset.value = withRepeat(
      withSequence(
        withDelay(DELAY, withTiming(-LEFT_INITIAL_VALUE, { duration: DURATION })),
        withDelay(DELAY, withTiming(LEFT_INITIAL_VALUE, { duration: DURATION }))
      ),
      -1,
      true
    )
    rightSideOffset.value = withRepeat(
      withSequence(
        withDelay(DELAY, withTiming(-RIGHT_INITIAL_VALUE, { duration: DURATION })),
        withDelay(DELAY, withTiming(RIGHT_INITIAL_VALUE, { duration: DURATION }))
      ),
      -1,
      true
    )
  }, [leftSideOffset, rightSideOffset])

  const animatedLeftStyle = useAnimatedStyle(() => ({
    transform: [{ translateY: leftSideOffset.value }],
  }))
  const animatedRightStyle = useAnimatedStyle(() => ({
    transform: [{ translateY: rightSideOffset.value }],
  }))

  return (
    <>
      <BlurView style={StyleSheet.absoluteFill} blurType="light" />
      <ContentContainer>
        <LogoContainer>
          <Animated.View
            style={[
              {
                width: 25,
                height: 40,
                right: -HORIZONTAL_OFFSET,
              },
              animatedLeftStyle,
            ]}
          >
            <SynchPayLeftSideLogo />
          </Animated.View>
          <Animated.View
            style={[
              {
                width: 25,
                height: 40,
                left: -HORIZONTAL_OFFSET,
              },
              animatedRightStyle,
            ]}
          >
            <SynchPayRightSideLogo />
          </Animated.View>
        </LogoContainer>
        <Spacing top={24} />
        <TextContainer>
          <Text
            fontSize={20}
            lineHeight={32}
            align="center"
            fontFamily="IBMPlexSans-Regular"
            color="gray800"
          >
            {loadingText}
          </Text>
        </TextContainer>
      </ContentContainer>
    </>
  )
}

const LogoContainer = styled.View`
  flex-direction: row;
`

const ContentContainer = styled.View`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
`

const TextContainer = styled.View``
